import Paper from '@mui/material/Paper'
import { Skeleton } from '@mui/material'
import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import { useReportMenuCommonLayoutLoadingStateStyles } from './ReportMenuCommonLayoutLoadingState.styles'
import DefaultCard from '../card/DefaultCard'

type ReportMenuCommonLayoutLoadingStateProps = {
    title: string
    subtitle: string
    tableTitle: string
    tableSubTitle?: string
    showFilter?: boolean
    isMenuOpen: boolean
}

const ReportMenuCommonLayoutLoadingState: React.FC<
    ReportMenuCommonLayoutLoadingStateProps
> = ({
    title,
    subtitle,
    tableTitle,
    tableSubTitle,
    showFilter,
    isMenuOpen
}) => {
    const styles = useReportMenuCommonLayoutLoadingStateStyles()
    const rows = new Array(10)
    const items = new Array(5)

    return (
        <div className={styles.container}>
            <div>
                <div className={styles.subheaderContainer}>
                    <div>
                        <h2 className={styles.title}>{title}</h2>
                        <p className={styles.subTitle}>{subtitle}</p>
                    </div>
                </div>

                {showFilter && (
                    <Paper className={styles.filterContainer}>
                        <Skeleton
                            height={50}
                            width={88}
                            className={styles.filter}
                        />
                        <Skeleton
                            height={50}
                            width={350}
                            className={styles.filter}
                        />
                    </Paper>
                )}
                <DefaultCard title={tableTitle} subTitle={tableSubTitle}>
                    <div className={styles.table}>
                        {rows.map((rowItem) => (
                            <div className={styles.row} key={uuidv4()}>
                                {items.map((item) => (
                                    <Skeleton
                                        className={`${styles.bar} ${styles.marginHorizontal10}`}
                                        height={30}
                                        key={uuidv4()}
                                    />
                                ))}
                            </div>
                        ))}
                    </div>
                </DefaultCard>
            </div>
        </div>
    )
}

export default ReportMenuCommonLayoutLoadingState
